import { useViewport } from 'components/general/useViewPort'
import { findArray } from 'helpers/utils';
import MirsTable from 'components/general/table/Table.js';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export const FblTeamStatistics = ({ data, stats }) => {
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
  const tableColumns = useMemo(() =>
    [
      {
        id: 'TeamTotals',
        Header: <Label data={'HeaderTeamTotals'} sport={mirs_discipline} />,
        accessor: 'code',
        className: 'text-start w-40',
        Cell: (props) => {
          let row = props.cell.row.original
          let label = row.header ? row.header : props.value
          return (
            <Label data={label} sport={mirs_discipline} />
          )
        }
      },
      ColumTeam(data, 'Team-Home-Total', null, 1, null, isMobile),
      ColumTeam(data, 'Team-Away-Total', null, 2, null, isMobile),
    ], [data]
  )
  return (
    <MirsTable
      id={`mirs-table-team-statistics-${mirs_rsc}`}
      data={stats}
      columns={tableColumns}
      showLoading={false}
    />
  )
}

function ColumTeam(data, idColum, header, startSortOrder, athleteOrder, isMobile) {
  let team = findArray(data.items, { startSortOrder: [startSortOrder] });
  let participant = team?.participant;
  let headerText = <Label data={'HeaderTotal'} />
  if (athleteOrder) {
    team = findArray(team?.teamAthletes, { order: [athleteOrder] })
    participant = team?.athlete
  }
  if (!header) {
    headerText = TeamHeader(data, startSortOrder, isMobile)
  }

  return {
    id: idColum,
    Header: headerText,
    headerClassName: "text-center",
    accessor: 'code',
    className: 'text-center w-30',
    Cell: (props) => {

      //Change made to add the option of choosing which period to display the stats
      let teamValue
      teamValue = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === props.value);

      let component = props.cell.row.original.component !== undefined ? props.cell.row.original.component : '-';
      let paint = props.cell.row.original.paint !== undefined ? props.cell.row.original.paint : '-';
      let code = props.cell.row.original.code !== undefined ? props.cell.row.original.code : '';
      let label = props.cell.row.original.label !== undefined ? props.cell.row.original.label : '';
      let noData = props.cell.row.original.noData !== undefined ? props.cell.row.original.noData : '';
      let bold = props.cell.row.original.bold !== undefined ? props.cell.row.original.bold : '';

      switch (component) {
        case "type2":
          return (<TeamStatsType2 value={teamValue?.value} attempt={teamValue?.attempt} percent={teamValue?.percent} noData={noData} bold={bold} />)
        case "type3":
          return (<TeamStatsType3 value={teamValue?.value} paint={findArray(teamValue?.extendedStatsItems, { code: [paint] }).value} noData={noData} bold={bold} />)
        case "type4":
          return (<TeamStatsType4 value={teamValue?.value} attempt={teamValue?.attempt} percent={teamValue?.percent} paint={paint} team={team} code={code} noData={noData} bold={bold} />)
        case "type5":
          return (<TeamStatsType5 paint={paint} code={code} team={team} noData={noData} bold={bold} />)
        case "type6":
          return (<TeamStatsType6 value={teamValue?.value} noData={noData} bold={bold}
            won={findArray(teamValue?.extendedStatsItems, { code: ['SSL'] }).value}
            lost={findArray(teamValue?.extendedStatsItems, { code: ['NOS'] }).value}
            undecided={findArray(teamValue?.extendedStatsItems, { code: ['UNJ'] }).value}
          />)
        case "type7":
          return (<TeamStatsType7 value={teamValue?.value} attempt={teamValue?.attempt} noData={noData} bold={bold} />)
        case "type8":
          return (<TeamStatsType8 noData={noData} percent={team.statsItems?.find(filter => (filter?.pos === undefined || filter?.pos === 'TOT') && filter?.code === paint)?.percent} bold={bold} />)
        case "type9":
          return (<TeamStatsType9 attempt={teamValue?.attempt} noData={noData} bold={bold} />)
        case "type10":
          return (<TeamStatsType10 paint={paint} code={code} team={team} noData={noData} bold={bold} />)
        case "type11":
          return (<TeamStatsType11 paint={paint} code={code} team={team} noData={noData} label={label} bold={bold} />)
        case "type12":
          return (<TeamStatsType12 value={teamValue?.value} attempt={teamValue?.attempt} noData={noData} bold={bold} />)
        default:
          return (<TeamStatsType1 value={teamValue?.value} noData={noData} bold={bold} />)
      }
    },
  }
}

function TeamHeader(data, startSortOrder, isMobile) {
  let team = findArray(data.items, { startSortOrder: [startSortOrder] });
  return (
    <div className='d-flex align-items-center justify-content-center'>
      <div className='me-1'>
        <Noc className='me-1' {...team?.participant?.organisation} />
      </div>
      {!isMobile && <strong>
        <Competitor hidePicture={true} hideNoc={true} {...team?.participant} />
      </strong>}
    </div>
  )
}

// SE MUESTRA SOLO UN VALOR '25'
function TeamStatsType1({ value, noData, bold }) {
  return (
    <span className={bold}>
      {value !== undefined ? value : noData}
    </span>
  )
}
// SE MUESTRAN TRES VALORES '2/4 50%'
function TeamStatsType2({ value, attempt, percent, noData, bold }) {
  return (
    <>
      {value !== undefined ? value + '/' + attempt + ' ' + percent + '%' : noData}
    </>
  )
}
// SE MUESTRAN DOS VALORES '1 (5)' 
function TeamStatsType3({ value, paint, noData, bold }) {
  return (
    <>
      {value !== undefined ? value + ' (' + paint + ')' : noData}
    </>
  )
}
// SE MUESTRAN TRES VALORES 'EQUIPO 2/4 50%'
function TeamStatsType4({ value, attempt, percent, paint, team, code, noData, bold }) {
  let teamCode = findArray(team.statsItems, { code: [paint] });
  let teamValue = findArray(teamCode?.extendedStatsItems, { code: [code] }).value;
  if (teamValue === undefined)
    return (
      <>
        {value !== undefined ? '0 (' + value + '/' + attempt + ' ' + percent + '%)' : noData}
      </>
    )
  else {
    return (
      <>
        {teamValue} {value !== undefined ? '(' + value + '/' + attempt + ' ' + percent + '%)' : noData}
      </>
    )
  }
}
// SE MUESTRA UN VALOR DE UNA EXTENSION 
function TeamStatsType5({ paint, code, team, noData, bold }) {
  let teamPaint = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === 'TOT') && filter.code === paint);
  let extendedStats = findArray(teamPaint?.extendedStatsItems, { code: [code] }).value;
  return (
    <>
      {extendedStats !== undefined ? extendedStats : noData}
    </>
  )
}
// SE MUESTRAN CUATRO VALORS '25(10/2/5)' 
function TeamStatsType6({ value, won, lost, undecided, noData, bold }) {
  return (
    <>
      {value !== undefined ? value + '(' + won + '/' + lost + '/' + undecided + ')' : noData}
    </>
  )
}
// SE MUESTRAN DOS VALORES '2/4'
function TeamStatsType7({ value, attempt, noData, bold }) {
  return (
    <>
      {value !== undefined ? value + '/' + attempt : noData}
    </>
  )
}
// SE MUESTRAN UN PORCENTAJE PERO OJO QUE ES TEMPORAL, EN LA LLAMADA SE FUERZA EL CAMBIO DEL LABEL
function TeamStatsType8({ percent, noData, bold }) {
  return (
    <>
      {percent !== undefined ? percent : noData}
    </>
  )
}

//RETURNS ONLY THE ATTEMPT VALUE
function TeamStatsType9({ attempt, bold }) {
  return (
    <>
      {attempt !== undefined ? attempt : ''}
    </>
  )
}
// SE MUESTRA UN VALOR DE UNA EXTENSION DE CUALQUIER PERIODO
function TeamStatsType10({ paint, code, team, noData, period, bold }) {
  let teamPaint = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === period) && filter.code === paint);
  let extendedStats = findArray(teamPaint?.extendedStatsItems, { code: [code] }).value;
  return (
    <span className={bold}>
      {extendedStats !== undefined ? extendedStats : noData}
    </span>
  )
}
// SE MUESTRA UN VALOR DE UNA EXTENSION DE CUALQUIER PERIODO MAS UN LABEL,  88KM/H
function TeamStatsType11({ paint, code, team, noData, period, label, bold }) {
  let teamPaint = team.statsItems?.find(filter => (filter.pos === undefined || filter.pos === period) && filter.code === paint);
  let extendedStats = findArray(teamPaint?.extendedStatsItems, { code: [code] }).value;
  return (
    <>
      {extendedStats !== undefined ? <>{extendedStats}<Label data={label} /></> : noData}
    </>
  )
}
// SE MUESTRAN DOS VALORES '4/2'
function TeamStatsType12({ value, attempt, noData, bold }) {
  return (
    <>
      {attempt !== undefined ? attempt + '/' + value : noData}
    </>
  )
}

